import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { Notify } from '../../../Helpers/notification';
import { Fetcher } from '../../../Helpers/fetcher';

import "./index.css"

const CreateModule = ({ app }) => {
    const history = useHistory();
    const apiPath = app.apiPath;

    const childWrapperRef = useRef(null);
    const [parentName, setParentName] = useState('');
    const [childModules, setChildModules] = useState([
        { moduleName: '' }
    ]);

    const handleAdd = () => {
        const lastChild = childModules[childModules.length - 1];

        if (!lastChild.moduleName.trim()) {
            Notify.notify("Please fill the current child module before adding another");
            return;
        }

        setChildModules([...childModules, { moduleName: '' }]);
    };

    const handleRemove = (index) => {
        const updated = [...childModules];
        updated.splice(index, 1);

        setChildModules(
            updated.length ? updated : [{ moduleName: '' }]
        );

        Notify.notify("Child module removed");
    };

    const handleChange = (index, value) => {
        const updated = [...childModules];
        updated[index].moduleName = value;
        setChildModules(updated);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!parentName.trim()) {
            Notify.notify("Parent module name is required");
            return;
        }

        const filteredChildren = childModules
            .filter(c => c.moduleName.trim() !== "")
            .map(child => ({
                moduleName: child.moduleName
            }));

        const payload = {
            mname: parentName,
            childModule: JSON.stringify(filteredChildren)
        };

        Fetcher.post(`${apiPath}/api/obd/add/acl/modules`, {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    Notify.notify('Parameters Incorrect');
                } else {
                    Notify.notify(res.message);
                    history.push("/module");
                }
            })
            .catch(err => {
                console.log('Error in Adding Module', err);
                Notify.notify('Error in Adding Module');
            });
    };

    useEffect(() => {
        if (childWrapperRef.current) {
            childWrapperRef.current.scrollTop =
                childWrapperRef.current.scrollHeight;
        }
    }, [childModules]);
    return (
        <Card>
            <Card.Header>ACL Create Module</Card.Header>
            <Card.Body>

                <Form onSubmit={handleSubmit}>

                    <Form.Group className="mb-3">
                        <Form.Label>Parent Module</Form.Label>
                        <Form.Control
                            type="text"
                            value={parentName}
                            onChange={(e) => setParentName(e.target.value)}
                            placeholder="Enter parent module"
                        />
                    </Form.Group>

                    <Form.Label>Child Modules</Form.Label>

                    <div className="child-module-wrapper" ref={childWrapperRef}>

                        {childModules.map((child, index) => (
                            <Row key={index} className="mb-2">
                                <Col>
                                    <Form.Control
                                        type="text"
                                        value={child.moduleName}
                                        onChange={(e) =>
                                            handleChange(index, e.target.value)
                                        }
                                        placeholder="Child module name"
                                    />
                                </Col>

                                <Col xs="auto">
                                    <Button
                                        variant="danger"
                                        onClick={() => handleRemove(index)}
                                    >
                                        Remove
                                    </Button>
                                </Col>
                            </Row>
                        ))}

                    </div>

                    <Button
                        variant="secondary"
                        onClick={handleAdd}
                        className="mb-3 mt-2"
                    >
                        + Add Child
                    </Button>

                    <div>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </div>

                </Form>

            </Card.Body>
        </Card>
    );
};

export default CreateModule;